<template>
  <div class="license-settings">
    <v-btn
      color="primary"
      class="filter-btn"
      fixed
      dark
      fab
      top
      right
      @click.stop="filterDrawer = !filterDrawer"
    >
      Filter
    </v-btn>

    <v-navigation-drawer
      v-model="filterDrawer"
      class="filter-nav"
      width="250"
      fixed
      right
      dark
      hide-overlay
    >
      <v-list class="pa-1">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">Filters:</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click.stop="filterDrawer = !filterDrawer">
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-list class="pt-0">
        <v-divider></v-divider>

        <v-list-item class="pt-2 pb-4">
          <v-text-field
            v-model="searchTerm"
            label="Search"
            append-icon="search"
            clearable
            hide-details
          ></v-text-field>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-checkbox
              v-model="boundFilter"
              label="Bound"
              color="primary"
              :disabled="unboundFilter"
              hide-details
            ></v-checkbox>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-checkbox
              v-model="unboundFilter"
              label="Unbound"
              color="primary"
              :disabled="boundFilter"
              hide-details
            ></v-checkbox>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-checkbox
              v-model="selected"
              label="Mobile"
              value="Mobile"
              color="primary"
              :disabled="selectedFilter === 'Desktop' || selectedFilter === 'Multi-Sport'"
              hide-details
            ></v-checkbox>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-checkbox
              v-model="selected"
              label="Desktop"
              value="Desktop"
              color="primary"
              :disabled="selectedFilter === 'Mobile' || selectedFilter === 'Multi-Sport'"
              hide-details
            ></v-checkbox>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-checkbox
              v-model="selected"
              label="Multi-Sport"
              value="Multi-Sport"
              color="primary"
              :disabled="selectedFilter === 'Mobile' || selectedFilter === 'Desktop'"
              hide-details
            ></v-checkbox>
          </v-list-item-action>
        </v-list-item>
        <v-list-item class="pt-4">
          <v-btn color="info" block @click.stop="clearFilters">clear</v-btn>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- show filter card instead of nav drawer -->
    <!-- <transition name="fadeDown" appear>
      <v-card
        :class="`card-container filter-container ${darkMode ? 'dark-border' : 'light-border'}`"
        flat
      >
        <v-layout row wrap class="py-0">
          <v-flex xs12 class="py-0">
            <v-card-title class="pa-0">
              <h3>Filters:</h3>
            </v-card-title>
          </v-flex>
          <v-flex xs6 sm3 md2 class="py-0 px-1">
            <v-checkbox
              v-model="boundFilter"
              label="Bound"
              color="primary"
              :disabled="unboundFilter"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 md2 class="py-0 px-1">
            <v-checkbox
              v-model="unboundFilter"
              label="Unbound"
              color="primary"
              :disabled="boundFilter"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 md2 class="py-0 px-1">
            <v-checkbox
              v-model="selected"
              label="Mobile"
              value="Mobile"
              color="primary"
              :disabled="selectedFilter === 'Desktop' || selectedFilter === 'Multi-Sport'"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 md2 class="py-0 px-1">
            <v-checkbox
              v-model="selected"
              label="Desktop"
              value="Desktop"
              color="primary"
              :disabled="selectedFilter === 'Mobile' || selectedFilter === 'Multi-Sport'"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs6 sm3 md3 class="py-0 px-1">
            <v-checkbox
              v-model="selected"
              label="Multi-Sport"
              value="Multi-Sport"
              color="primary"
              :disabled="selectedFilter === 'Mobile' || selectedFilter === 'Desktop'"
              hide-details
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md6 class="py-01 px-1">
            <v-text-field
              v-model="searchTerm"
              class="pt-01 pb-2"
              label="Search"
              append-icon="search"
              clearable
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </transition> -->

    <v-card
      v-if="isLoading"
      :class="`card-container ${darkMode ? 'dark-border' : 'light-border'}`"
      flat
    >
      <div class="progress">
        <pulse-loader :color="$options.loaderColor"></pulse-loader>
      </div>
    </v-card>

    <div v-else>
      <transition-group name="list" appear>
        <LicenseItem
          v-for="license in allLicenses"
          :key="license.license.id"
          :license="license"
          :expired="checkLicense(license)"
          :loading="isLoading"
          :is-loading="isLoading"
          :license-type="license.type"
          @snackbarStatus="snackbarStatus"
        />
      </transition-group>
    </div>

    <div
      v-if="
        !allLicenses.length &&
        !loadingMobileLicense &&
        !loadingMultiSportLicense &&
        !loadingLicenses
      "
      class="empty-state-container-mobile"
    >
      <v-layout wrap>
        <v-flex v-if="hasFiltersApplied" xs12>
          <v-card
            :class="`card-container text-center ${darkMode ? 'dark-border' : 'light-border'}`"
            flat
          >
            <v-card-text>
              <v-alert
                :value="true"
                type="info"
                :color="$vuetify.theme.dark ? 'warning' : 'error'"
                class="my-2"
                outlined
              >
                You have filters applied. Clear your filters to view your full list of licenses.
              </v-alert>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card :class="`card-container ${darkMode ? 'dark-border' : 'light-border'}`" flat>
            <EmptyState
              message="It looks like no licenses were found. Try adjusting your search criteria or contact an E6 agent to get yourself set up with one."
            ></EmptyState>
          </v-card>
        </v-flex>
      </v-layout>
    </div>

    <SettingsBottomNav :limited-user="limitedUser" />

    <!-- snackbar -->
    <v-snackbar
      v-model="snackbar.status"
      :timeout="snackbar.timeout"
      :color="snackbar.type"
      top
      right
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.status = false">
        {{ $t('general.close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import meMixin from '@/mixins/meMixin';
import utilityMixin from '@/mixins/utilityMixin';
import EmptyState from '@/components/EmptyState';
import LicenseItem from '@/components/settings/LicenseItem';
import SettingsBottomNav from '@/components/SettingsBottomNav';
import { loaderColor, loaderSize } from '@/lib/constants';
import { isDev } from '@/utils/helpers';

export default {
  name: 'LicenseSettings',

  components: {
    EmptyState,
    LicenseItem,
    SettingsBottomNav,
  },

  mixins: [meMixin, utilityMixin],

  props: {
    limitedUser: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      allLicenseList: [],
      boundFilter: false,
      unboundFilter: false,
      selected: [],
      searchTerm: '',
      filterDrawer: false,
      snackbar: {
        type: '',
        text: false,
        status: false,
        timeout: 6000,
      },
      active: null,

      rules: {
        prodKey: [
          (k) => {
            return !!k || 'Product key is required';
          },
          (k) => {
            return (
              (k && k.length === 23) ||
              'Product key must be 20 characters long separated by dashes (23 total)'
            );
          },
          (k) => {
            //* Testing out using input mask to avoid having to type dashes
            //* mask="NNNNN-NNNNN-NNNNN-NNNNN" needs to be added to text-field along with return-unmasked-value
            // const code = `${k.slice(0, 5)}${k.slice(5, 10)}${k.slice(10, 15)}${k.slice(15, 23)}`
            // console.log('code:', code)
            // console.log('pattern:', pattern.test(code))
            const pattern = /([A-Za-z0-9]){5}-([A-Za-z0-9]){5}-([A-Za-z0-9]){5}-([A-Za-z0-9]){5}/;
            return pattern.test(k) || 'Invalid Product Key.';
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters({
      licenseList: 'licenses/licenseList',
      multiLicenseList: 'licenses/multiLicenseList',
      mobileLicenseList: 'licenses/mobileLicenseList',
      loadingLicenses: 'licenses/loadingLicenses',
      loadingMobileLicense: 'licenses/loadingMobileLicense',
      loadingMultiSportLicense: 'licenses/loadingMultiSportLicense',
      unbound: 'licenses/unbound',
      errorMessage: 'licenses/errorMessage',
      showTransactions: 'transactions/show',
    }),

    isLoading() {
      return this.loadingMobileLicense || this.loadingLicenses || this.loadingMultiSportLicense;
    },

    selectedFilter() {
      return this.selected[0];
    },

    allLicenses() {
      let licenses = [];

      if (
        !this.licenseList?.length &&
        !this.mobileLicenseList?.length &&
        !this.multiLicenseList?.length
      ) {
        return licenses;
      }

      this.licenseList?.map((license) => {
        licenses.push(
          Object.assign(license, {
            // type: 'Desktop',
            //* Temp setup for agnostic license changes
            type: isDev()
              ? license?.license?.license_key.includes('desktop')
                ? 'Desktop'
                : 'Mobile'
              : 'Desktop',
          })
        );
      });
      this.multiLicenseList?.map((license) => {
        licenses.push(
          Object.assign(license, {
            type: 'Multi-sport',
          })
        );
      });
      // this.mobileLicenseList?.map((license) => {
      //   licenses.push(
      //     Object.assign(license, {
      //       type: 'Mobile',
      //     })
      //   );
      // });

      licenses
        ?.sort((a, b) => {
          // sort by first two characters alphabetically
          const aFirstTwo = a?.type?.substring(0, 2);
          const bFirstTwo = b?.type?.substring(0, 2);
          if (aFirstTwo > bFirstTwo) return 1;
          if (aFirstTwo < bFirstTwo) return -1;
          return 0; // Handles equality case
        })
        .sort((a, b) => {
          const aAvail = a?.license?.available;
          const bAvail = b?.license?.available;
          return aAvail === bAvail ? 0 : aAvail ? 1 : -1;
        });

      if (this.boundFilter) {
        licenses = licenses.filter(this.filterBound);
      }
      if (this.unboundFilter) {
        licenses = licenses.filter(this.filterUnbound);
      }
      if (this.selected.length) {
        licenses = licenses.filter(this.filterType);
      }

      if (this.searchTerm) {
        //* Example to filter just license id
        // return licenses.filter(license =>
        //   license.license.id.includes(this.searchTerm.toLowerCase())
        // );

        // return this.filterLicenseArray(licenses, this.searchTerm);
        licenses = this.filterLicenseArray(licenses, this.searchTerm);
      }

      // console.log('licenses:', licenses);
      return licenses;
    },

    hasFiltersApplied() {
      return (
        !!this.searchTerm?.length ||
        this.boundFilter ||
        this.unboundFilter ||
        !!this.selected?.length
      );
    },
  },

  beforeCreate() {
    //* Fetch user's licenses - calls desktop license list - agnostic pulls ALL types
    this.$store
      .dispatch('licenses/all')
      // .then((res) => {
      //   console.log('res:', res);
      // })
      .catch((err) => {
        console.error(err);
        this.$root.vtoast.show({
          text: `Error loading licenses`,
          color: `error`,
        });
      });

    //* If AGNOSTICLICENSE var is active, disable this mobile license call
    //* disabling this as updates return all licenses in just one
    //* does break filtering by type if it's not a new license type - filtering working still? Check more
    // if (!isDev()) {
    //   this.$store.dispatch('licenses/mobile').catch((err) => {
    //     return console.error(err);
    //   });
    // }
  },

  created() {
    //* non-reactive constants
    this.$options.loaderColor = loaderColor;
    this.$options.loaderSize = loaderSize;
  },

  methods: {
    snackbarValues(status = 'true', type = 'success', text) {
      this.snackbar.status = status;
      this.snackbar.type = type;
      this.snackbar.text = text;
    },

    snackbarStatus(data) {
      this.snackbarValues(data.status, data.type, data.text);
      //* Just refetch all licenses after unbind. Preserves original sorting.
      this.$store.dispatch('licenses/all');

      //* If AGNOSTICLICENSE var is active, disable this mobile license call
      // if (!isDev()) {
      //   this.$store.dispatch('licenses/mobile');
      // }
    },

    checkLicense(license) {
      const { expiresAt } = license?.license;
      let expired = false;
      // * Check if license expiresAt is before today
      expired = expiresAt ? moment(license?.license?.expiresAt).isBefore(moment()) : false;
      if (expired) {
        license.license.expiredLicense = expired;
      }
      return expired;
    },

    filterUnbound(license) {
      const hasClientTrackingID = license?.license?.authentication?.clientTrackingID;
      return !hasClientTrackingID ? license : null;
    },

    filterBound(license) {
      const hasClientTrackingID = license?.license?.authentication?.clientTrackingID;
      return hasClientTrackingID ? license : null;
    },

    filterType(license) {
      const [licenseType] = this.selected || [];
      return license.type.toLowerCase() === licenseType.toLowerCase();
    },

    filterLicenseArray(arr, searchTerm) {
      //* courses, permissions, trackingSystems not included. Can be turned on though if desired.
      return arr.filter(
        ({
          // courses,
          // permissions,
          // trackingSystems,
          clientName,
          type,
          license: { id, name, authentication: { clientTrackingID } = {} },
        }) =>
          // console.log('courses:', courses);
          // console.log('permissions:', permissions);
          // console.log('trackingSystems:', trackingSystems);
          // console.log('trial:', trial);
          // const courseValues = courses.map(({ name }) => {
          //   console.log('c name:', name);
          //   return name;
          // });
          // const permissionValues = permissions.map(({ name }) => {
          //   console.log('p name:', name);
          //   return name;
          // });
          // const tsValues = trackingSystems.map(({ name }) => {
          //   console.log('ts name:', name);
          //   return name;
          // });

          {
            return [
              clientName,
              type,
              id,
              name,
              clientTrackingID,
              // ...courseValues,
              // ...permissionValues,
              // ...tsValues,
            ].some((value) => {
              if (value) {
                return value.toString().toLowerCase().includes(searchTerm);
              }
            });
          }
      );
    },

    clearFilters() {
      this.boundFilter = false;
      this.unboundFilter = false;
      this.selected = [];
      this.searchTerm = '';
    },
  },
};
</script>

<style scoped>
.empty-state-container {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  padding: 24px;
}

.empty-state-container-mobile {
  display: flex;
  justify-content: center;
  font-size: 20px;
}

.tooltip {
  margin-top: 22px;
}

.license-settings {
  margin-top: -65px;
  min-height: calc(60vh - 65px) !important;
}

.license-settings .card-container {
  padding: 30px !important;
  margin-bottom: 20px;
  border-radius: 10px;
  border-radius: var(--border-10);
}

.license-settings .filter-container {
  padding: 20px 30px !important;
}

/* remove margin top on checkbox fields */
* >>> .v-input--selection-controls {
  margin-top: 5px;
}

.licenses {
  box-shadow: none;
  margin-top: 24px;
}

.key {
  margin-right: 10px;
  margin-left: -10px;
}

.type {
  font-size: 16px;
}

.card {
  display: flex;
  flex-direction: column;
}

.details {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.detail {
  display: flex;
  flex-direction: column;
  width: 300px;
}

.detail-header {
  font-weight: 500;
}

.license-expiration {
  color: rgba(0, 0, 0, 0.6);
  font-style: italic;
}

.theme--dark .license-expiration {
  color: rgba(255, 255, 255, 0.8);
}

ul {
  list-style: none;
  padding: 0;
  columns: 3;
  -webkit-columns: 3;
  -moz-columns: 3;
}

.v-expansion-panel__container {
  background-color: rgba(0, 0, 0, 0) !important;
}

.divider {
  margin: 10px 0;
}

.row {
  display: flex;
  flex-direction: row;
}

.space-between {
  justify-content: space-between;
}

.features {
  margin-top: 16px;
}

.feature {
  width: 100%;
  margin-right: 24px;
}

.unbind {
  margin-top: 24px;
}

.type {
  margin-left: 24px;
}

.headers {
  margin: 14px;
  width: 95%;
}

.stat-box {
  text-align: left;
  min-width: 150px;
}

.progress {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  /* margin-top: 200px; */
}

.filter-nav {
  z-index: 6 !important;
}

.filter-btn {
  border-radius: 0;
  right: 0 !important;
  top: 10vh !important;
}

* >>> .theme--dark.v-label {
  color: #efefef;
  color: var(--offWhite);
}

.tg-title {
  margin-left: 48px;
  font-size: 24px;
}

.tab-bar {
  background-color: rgba(0, 0, 0, 0) !important;
}

.tabs {
  margin-top: 24px;
}

.tab-card {
  background-color: rgba(0, 0, 0, 0) !important;
  min-height: 150px;
}

.mobile-detail {
  display: none;
  margin-top: 12px;
}

.hidden {
  display: none;
}

.error-card {
  border-color: #ff0000 !important;
}

.success-card {
  border-color: #48a84c !important;
}

/* could delete this */
.error-icon,
.success-icon {
  font-size: 2.625rem;
}

/* License Status Box Transition */
.bounce-enter-active {
  animation: bounce-in 0.5s;
  transition: opacity 0.3s ease;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
  transition: opacity 0.3s ease;
}

.bounce-enter,
.bounce-leave-to {
  opacity: 0;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 724px) {
  .nickname {
    display: none;
  }

  ul {
    columns: 1;
  }
}

@media (max-width: 600px) {
  .license-settings {
    margin-top: 0px;
  }

  .text {
    font-size: 12px;
    width: 120px;
  }

  .nickname {
    display: none;
  }

  .simID {
    display: none;
  }

  .mobile-detail {
    display: inline;
  }

  ul {
    columns: 1;
  }

  .stat-box {
    min-width: 125px;
  }

  .detail {
    width: 240px;
  }

  .detail-value {
    font-size: 14px;
    word-wrap: break-word;
  }
}
</style>
